import { createContext, useContext } from 'react';
import type { TypemarkContextType, TypemarkContextProviderProps } from './types';

export const TypemarkContext = createContext<TypemarkContextType | undefined>(undefined);

export const useTypemarkContext = () => {
  const context = useContext(TypemarkContext);

  return context;
};

export const TypemarkContextProvider = ({ children, value }: TypemarkContextProviderProps) => {
  return <TypemarkContext.Provider value={value}>{children}</TypemarkContext.Provider>;
};
